import api from "./api";

const atualizarNotificacoesAssinatura = () => {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("assinatura:notifications-refresh"));
  }
};

const listarPendencias = async (filtros = {}) => {
  const response = await api.get("/assinatura-digital/pendencias", {
    params: filtros,
  });
  return response.data;
};

const listarAdministradores = async () => {
  const response = await api.get("/assinatura-digital/administradores");
  return response.data;
};

const buscarCertificado = async () => {
  const response = await api.get("/assinatura-digital/certificado");
  return response.data;
};

const salvarCertificado = async (dados) => {
  const formData = new FormData();

  formData.append("certificado", dados.certificado);
  formData.append("senha", dados.senha);
  formData.append("certificadoTitular", dados.certificadoTitular || "");
  formData.append("certificadoCnpj", dados.certificadoCnpj || "");
  formData.append("certificadoSerial", dados.certificadoSerial || "");
  formData.append("validadeCertificado", dados.validadeCertificado || "");
  formData.append("observacao", dados.observacao || "");

  const response = await api.post(
    "/assinatura-digital/certificado",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    },
  );
  return response.data;
};

const desativarCertificado = async (id) => {
  await api.delete(`/assinatura-digital/certificado/${id}`);
};

const buscarPendencia = async (IDArquivoAssinaturaPendencia) => {
  const response = await api.get(
    `/assinatura-digital/pendencias/${IDArquivoAssinaturaPendencia}`,
  );
  return response.data;
};

const solicitarAssinaturaArquivo = async (IDArquivo) => {
  const response = await api.post(
    `/assinatura-digital/arquivo/${IDArquivo}/solicitar`,
  );
  atualizarNotificacoesAssinatura();
  return response.data;
};

const aprovarPendencia = async (IDArquivoAssinaturaPendencia, origem) => {
  const response = await api.put(
    `/assinatura-digital/pendencias/${IDArquivoAssinaturaPendencia}/aprovar`,
    origem ? { origem } : {},
  );
  atualizarNotificacoesAssinatura();
  return response.data;
};

const recusarPendencia = async (IDArquivoAssinaturaPendencia, justificativa) => {
  const response = await api.put(
    `/assinatura-digital/pendencias/${IDArquivoAssinaturaPendencia}/recusar`,
    { justificativa },
  );
  atualizarNotificacoesAssinatura();
  return response.data;
};

const solicitarAjustePendencia = async (
  IDArquivoAssinaturaPendencia,
  justificativa,
) => {
  const response = await api.put(
    `/assinatura-digital/pendencias/${IDArquivoAssinaturaPendencia}/solicitar-ajuste`,
    { justificativa },
  );
  atualizarNotificacoesAssinatura();
  return response.data;
};

const assinarPendencia = async (IDArquivoAssinaturaPendencia, opcoes = {}) => {
  const response = await api.post(
    `/assinatura-digital/pendencias/${IDArquivoAssinaturaPendencia}/assinar`,
    opcoes,
  );
  atualizarNotificacoesAssinatura();
  return response.data;
};

const buscarConfigDiretorio = async (IDDiretorio) => {
  const response = await api.get(`/diretorio/${IDDiretorio}/assinatura-config`);
  return response.data;
};

const salvarConfigDiretorio = async (IDDiretorio, config) => {
  const response = await api.put(
    `/diretorio/${IDDiretorio}/assinatura-config`,
    config,
  );
  return response.data;
};

export const assinaturaDigitalService = {
  listarPendencias,
  listarAdministradores,
  buscarCertificado,
  salvarCertificado,
  desativarCertificado,
  buscarPendencia,
  solicitarAssinaturaArquivo,
  aprovarPendencia,
  recusarPendencia,
  solicitarAjustePendencia,
  assinarPendencia,
  buscarConfigDiretorio,
  salvarConfigDiretorio,
};
